import { QUANTUM_UI } from '../../../flags';
import { VideoFooter as VideoFooterNew } from './VideoFooter';
import { VideoFooter as VideoFooterOld } from './VideoFooter.old';
export var VideoFooter = QUANTUM_UI ? VideoFooterNew : VideoFooterOld;
